<template>
  <img draggable="false" :class="{shadow}" :src="actualSrc" alt="Calendar photo" />
</template>

<style scoped>
img {
  width: 100%;
  max-height: 100%;
  object-fit: contain;
  vertical-align: middle;
}

img.shadow {
  filter: drop-shadow(0px 0px 1px rgba(0, 0, 0, 0.3))
    drop-shadow(0px 0px 10px rgba(0, 0, 0, 0.4))
    drop-shadow(0px 0px 30px rgba(0, 0, 0, 0.5));
}
</style>

<script>
export default {
  props: {
    src: String,
    shadow: Boolean
  },
  computed: {
    actualSrc() {
      return `img/${this.src}.jpg`;
    }
  }
};
</script>